import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectHash, selectPathname } from 'src/redux/navigation/selectors';
import {
  getNextPageNumberNotLoaded,
  getPreviousPageNumberNotLoaded,
} from 'src/redux/products/utils/pageNumbers';
import { adaptStoreToPageURL } from './adaptStoreToPageURL';
import { buildListingsURL } from './buildListingsURL';

const adaptStoreToAdjacentPageURL = (
  state: ReduxApplicationState,
  getAdjacentPageNumber: (state: ReduxApplicationState) => number | null,
): string | null => {
  const pageNumber = getAdjacentPageNumber(state);

  if (pageNumber === null) {
    return null;
  }

  const params = adaptStoreToPageURL(state, pageNumber);
  return buildListingsURL(selectPathname(state), params, selectHash(state));
};

export const adaptStoreToPreviousPageURL = (state: ReduxApplicationState): string | null => {
  return adaptStoreToAdjacentPageURL(state, (currentState) => {
    return getPreviousPageNumberNotLoaded(currentState.products.pages);
  });
};

export const adaptStoreToNextPageURL = (state: ReduxApplicationState): string | null => {
  return adaptStoreToAdjacentPageURL(state, (currentState) => {
    return getNextPageNumberNotLoaded(
      currentState.products.pages,
      currentState.products.totalPages,
    );
  });
};
